import type { TalentDiscoveryRespGeoDataV3 } from '@revelio/data-access';

import { LocationType, type MapPoint } from '../../Chart/Map/types';

const COUNTRY_TYPE = 1 as const;
const METRO_AREA_TYPE = 2 as const;
const CITY_TYPE = 3 as const;
const STATE_TYPE = 4 as const;

export const transformTalentDiscoveryMapData = (
  rawMapData:
    | Array<TalentDiscoveryRespGeoDataV3 | null | undefined>
    | null
    | undefined
): MapPoint[] => {
  const result =
    rawMapData
      ?.map((d) => {
        if (!d || !d.lat || !d.lon) return null;
        let locationType: LocationType | null = null;

        if (d.type === CITY_TYPE) {
          locationType = LocationType.CITY;
        } else if (d.type === COUNTRY_TYPE) {
          locationType = LocationType.COUNTRY;
        } else if (d.type === METRO_AREA_TYPE) {
          locationType = LocationType.METRO_AREA;
        } else if (d.type === STATE_TYPE) {
          locationType = LocationType.STATE;
        }

        return {
          id: String(d.id),
          label: d.location,
          lat: d.lat,
          lon: d.lon,
          value: d.count ?? 0,
          locationType,
          tooltip: { type: d.type, id: d.id },
        } as MapPoint;
      })
      .filter((p): p is MapPoint => p !== null) ?? [];

  return result;
};
